import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { getHousekeepingApplicationMasterList_action, deleteHousekeepingApplicationMaster_action, insertUpdateHousekeepingApplicationMaster_action, insertUpdateMasterHousekeeping_action, getMasterHousekeeping_action } from '../../../../../actions/admin_module_action/master_action/manual_form_master_action/housekeeping_application_master_action'
import { toastError, toastSuccess } from "../../../../../utils/constants";
import Modal from "react-modal";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import Footer from "../../../../../common_components/Footer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";



class HousekeepingApplicationMasterList extends Component {

    // Initialize Constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            // currentPage: 1,
            HousekeepingApplicationList: [],
            deleteID: '',
            housekeepingRateList: [],
        }
        this.getMasterHousekeeping = this.getMasterHousekeeping.bind(this)
        this.getHousekeepingApplicationMasterList = this.getHousekeepingApplicationMasterList.bind(this)
        this.deleteHousekeepingApplicationMaster = this.deleteHousekeepingApplicationMaster.bind(this)
        this.handleAdd = this.handleAdd.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.addRateRow = this.addRateRow.bind(this)
        this.deleteRateRow = this.deleteRateRow.bind(this)
        this.handleRateChange = this.handleRateChange.bind(this)
        this.saveHousekeepingRates = this.saveHousekeepingRates.bind(this)
    }

    componentDidMount() {
        this.getHousekeepingApplicationMasterList()
        this.getMasterHousekeeping()
    }

    getMasterHousekeeping() {
        this.props.getMasterHousekeeping_action()
            .then((data) => {
                if (data.error != 1) {
                    var rateList = data.data ? data.data.map(r => ({
                        HouseKeepingID: r.HouseKeepingId,
                        Date: r.Date ? new Date(r.Date) : null,
                        RateInINR: r.RateINR,
                        RateInUSD: r.RateUSD,
                        action_id: 2
                    })) : []
                    this.setState({ housekeepingRateList: rateList, isLoading: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    getHousekeepingApplicationMasterList(status) {
        this.setState({ isLoading: true })
        this.props.getHousekeepingApplicationMasterList_action()
            .then((data) => {
                if (data.error != 1) {
                    var contactList = data.data[0]
                    var bankDetailsList = data.data[1]
                    var finalList = []
                    for (var i = 0; i < contactList.length; i++) {
                        for (var j = 0; j < bankDetailsList.length; j++) {
                            if (contactList[i].HousekeepingContactPersonID == bankDetailsList[j].HousekeepingContactPersonID) {
                                var mergObj = { ...contactList[i], ...bankDetailsList[j] }
                                finalList.push(mergObj)
                            }
                        }
                    }
                    console.log(finalList)
                    this.setState({ HousekeepingApplicationList: finalList })
                    this.setState({ isLoading: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    deleteHousekeepingApplicationMaster(id) {
        this.setState({ isLoading: true })
        this.props.deleteHousekeepingApplicationMaster_action(id, null)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    this.setState({ isLoading: false })
                    toastSuccess("deleted successfully")
                    setTimeout(() => {
                        this.getHousekeepingApplicationMasterList(1)
                    }, 200);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
                this.setState({ isOpen: false })
            })
            .catch((err) => {
                console.log(err)
            })
    }


    // Handle Add 
    handleAdd() {
        this.props.navigate('/housekeepingApplicationMasterAU', { state: { is_add: true } })
    }

    onDelete(id, index, status) {
        const { HousekeepingApplicationList } = this.state
        console.log(status, index)
        this.setState({ deleteID: id })
        this.setState({ isOpen: true, })
    }

    addRateRow() {
        const { housekeepingRateList } = this.state
        this.setState({
            housekeepingRateList: [...housekeepingRateList, {
                HouseKeepingID: 0,
                Date: null,
                RateInINR: '',
                RateInUSD: '',
                action_id: 1
            }]
        })
    }

    deleteRateRow(index) {
        const { housekeepingRateList } = this.state
        const row = housekeepingRateList[index]
        // If it's a new unsaved row, just remove it from the list
        // If it's an existing row (has ID), mark it for deletion via action_id = 3 and save immediately
        if (row.HouseKeepingID === 0) {
            const updated = housekeepingRateList.filter((_, i) => i !== index)
            this.setState({ housekeepingRateList: updated })
        } else {
            const updated = housekeepingRateList.map((r, i) =>
                i === index ? { ...r, action_id: 3 } : r
            )
            this.setState({ housekeepingRateList: updated }, () => {
                this.saveHousekeepingRates()
            })
        }
    }

    handleRateChange(index, field, value) {
        const { housekeepingRateList } = this.state
        const updated = housekeepingRateList.map((row, i) =>
            i === index ? { ...row, [field]: value } : row
        )
        this.setState({ housekeepingRateList: updated })
    }

    saveHousekeepingRates() {
        const { housekeepingRateList } = this.state

        const activeRows = housekeepingRateList.filter(r => r.action_id !== 3)
        if (activeRows.length === 0) {
            toastError("At least one rate entry is required")
            return
        }

        const udt = housekeepingRateList.map(row => ({
            HouseKeepingID: row.HouseKeepingID || 0,
            Date: row.Date ? row.Date.toISOString().split('T')[0] : null,
            RateInINR: parseInt(row.RateInINR) || 0,
            RateInUSD: parseInt(row.RateInUSD) || 0,
            action_id: row.action_id
        }))
        this.setState({ isLoading: true })
        this.props.insertUpdateMasterHousekeeping_action(udt)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Rates saved successfully")
                    this.getMasterHousekeeping()
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    render() {
        const { isLoading, isOpen, HousekeepingApplicationList, housekeepingRateList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="main-container">
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">Houserkeeping Application Master</h6>
                            </div>
                        </div>
                        <div className="admin-top-space p-2 px-0">
                            <div className="row m-0">
                            <div>
                                {/* Rate Table */}
                                <div className="card-header p-2" style={{ paddingLeft: "7px !important" }}>
                                    <h3 className="card-title" style={{ fontSize: 15 }}>
                                        Housekeeping Rates
                                    </h3>
                                </div>
                                <div className="table-responsive">
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                                        <thead>
                                            <tr>
                                                <th className="text-center" style={{ width: '60px' }}>Sr No.</th>
                                                <th className="text-center">Date</th>
                                                <th className="text-center">Rate per Guard (INR)</th>
                                                <th className="text-center">Rate per Guard (USD)</th>
                                                <th className="text-center" style={{ width: '80px' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {housekeepingRateList.filter(r => r.action_id !== 3).length > 0 ?
                                                housekeepingRateList.map((row, index) => {
                                                    if (row.action_id === 3) return null
                                                    const srNo = housekeepingRateList.slice(0, index + 1).filter(r => r.action_id !== 3).length
                                                    return (
                                                        <tr key={index}>
                                                            <td className="text-center">{srNo}</td>
                                                            <td className="text-center">
                                                                <DatePicker
                                                                    selected={row.Date}
                                                                    onChange={(date) => this.handleRateChange(index, 'Date', date)}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    className="form-control"
                                                                    placeholderText="Select date"
                                                                    popperProps={{ strategy: "fixed" }}
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="number"
                                                                    className="form-control text-center"
                                                                    value={row.RateInINR}
                                                                    min={0}
                                                                    step={1}
                                                                    onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                                                                    onChange={(e) => this.handleRateChange(index, 'RateInINR', e.target.value)}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="number"
                                                                    className="form-control text-center"
                                                                    value={row.RateInUSD}
                                                                    min={0}
                                                                    step={1}
                                                                    onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                                                                    onChange={(e) => this.handleRateChange(index, 'RateInUSD', e.target.value)}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <i
                                                                    className="fa fa-trash text-danger"
                                                                    style={{ cursor: 'pointer', fontSize: '16px' }}
                                                                    onClick={() => this.deleteRateRow(index)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                                : <tr><td className="text-center" colSpan={5}>No records found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="d-flex justify-content-between mt-2 mb-3">
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={this.addRateRow}
                                    >
                                        + Add Row
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-aqua btn-sm"
                                        onClick={this.saveHousekeepingRates}
                                    >
                                        Save Rates
                                    </button>
                                </div>

                                {/* Agency contact and bank details */}
                                <div
                                    className="card-header p-2"
                                    style={{ paddingLeft: "7px !important" }}
                                >
                                    <h3 className="card-title" style={{ fontSize: 15 }}>
                                        Agency contact and bank details
                                    </h3>
                                </div>
                                <div className="table-responsive ">
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                                        <thead>
                                            <tr>
                                                <th className="text-center">Name</th>
                                                <th className="text-center">Address</th>
                                                <th className="text-center">Telephone</th>
                                                <th className="text-center">Mobile</th>
                                                <th className="text-center">Fax</th>
                                                <th className="text-center">Primary Email</th>
                                                <th className="text-center">Secondary Email</th>
                                                <th className="text-center">Bank Name</th>
                                                <th className="text-center">Beneficiary Name</th>
                                                <th className="text-center">Beneficiary Address</th>
                                                <th className="text-center">Account Number</th>
                                                <th className="text-center">Swift Code</th>
                                                <th className="text-center">IFSC Code </th>
                                                <th className="text-center">PAN Number</th>
                                                <th className="text-center">GST Number</th>
                                                <th style={{ width: '60px' }} className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                HousekeepingApplicationList.length > 0 ? (HousekeepingApplicationList.map((data, i) => (
                                                    <tr key={data.HousekeepingContactPersonID}>
                                                        <td className="text-center">{data.Name}</td>
                                                        <td className="text-center">{data.Address}</td>
                                                        <td className="text-center">{data.Phone}</td>
                                                        <td className="text-center">{data.Mobile}</td>
                                                        <td className="text-center">{data.Fax}</td>
                                                        <td className="text-center">{data.PrimaryEmail}</td>
                                                        <td className="text-center">{data.SecondaryEmail}</td>
                                                        <td className="text-center">{data.BankName}</td>
                                                        <td className="text-center" >{data.BeneficiaryName}</td>
                                                        <td className="text-center" >{data.BeneficiaryAddress}</td>
                                                        <td className="text-center" >{data.AccountNumber}</td>
                                                        <td className="text-center" >{data.SwiftCode}</td>
                                                        <td className="text-center" >{data.IFSCCodeValue}</td>
                                                        <td className="text-center" >{data.PANNumber}</td>
                                                        <td className="text-center" >{data.GSTNumber}</td>
                                                        <td className="text-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-danger btn-sm"
                                                                onClick={(e) => this.onDelete(data.HousekeepingContactPersonID, i)}
                                                            >
                                                                <i className="fa fa-trash action_btn_table" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))) : <tr><td className="text-center" colSpan={20}>No record found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="text-end">
                                  
                                <button
                                    type="button"
                                    className="btn btn-aqua mt-2"
                                    onClick={() => this.handleAdd()}
                                >
                                    Add
                                </button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title">Do you really want to delete this record?</h5>

                                {/* <button type="button " class="close pop-close" data-dismiss="modal"
                                    onClick={() => this.setState({ isOpen: false })}
                                ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                            </div>
                            {/* <div class="modal-body">
                                <div class="row">
                                </div>
                            </div> */}
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop"
                                        onClick={(e) => this.deleteHousekeepingApplicationMaster(this.state.deleteID)}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
                <Footer />
            </>
        )
    }
}

export default withRouter(connect(null, { getHousekeepingApplicationMasterList_action, insertUpdateHousekeepingApplicationMaster_action, deleteHousekeepingApplicationMaster_action, insertUpdateMasterHousekeeping_action, getMasterHousekeeping_action })(HousekeepingApplicationMasterList));